export const getContract = (state) => state.contract
